export default __webpack_public_path__ + "static/media/Cobrastrike Band.6b32da50.jpg";